/* ----- フォーム表示 ----- */
document.addEventListener('DOMContentLoaded', function () {
  const documentBtn = document.querySelector('.document__btn');
  const documentForm = document.querySelector('.document__form');
  const documentText = document.querySelector('.document__text');

  documentBtn.addEventListener('click', function() {
    // フォームを表示
    documentForm.classList.add('is-active');
    // テキストとボタンを非表示
    documentText.classList.add('is-hidden');
    documentBtn.classList.add('is-hidden');
  });
});


/* ----- 資料請求ボタン スクロール ----- */
document.addEventListener('DOMContentLoaded', function() {
  // ========================================
  // Document系の処理
  // ========================================

  // 共通の処理を関数化
  function showDocumentForm() {
    const documentForm = document.querySelector('.document__form');
    const documentText = document.querySelector('.document__text');
    const documentBtn = document.querySelector('.document__btn');

    if (documentForm && documentText && documentBtn) {
      documentForm.classList.add('is-active');
      documentText.classList.add('is-hidden');
      documentBtn.classList.add('is-hidden');
    }
  }

  // document__btnの処理
  const documentBtn = document.querySelector('.document__btn');
  if (documentBtn) {
    documentBtn.addEventListener('click', function() {
      showDocumentForm();
    });
  }

  // js-documentクラスのボタン処理（スマホのみ）
  const jsDocumentBtns = document.querySelectorAll('.js-document');

  jsDocumentBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      // スマホ判定（768px以下）
      if (window.innerWidth < 768) {
        e.preventDefault();

        const target = document.getElementById('document-sp');
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          // スクロール後にフォーム表示処理を実行
          setTimeout(function() {
            showDocumentForm();
          }, 500);
        }
      }
    });
  });

  // ========================================
  // 汎用的なスムーズスクロール
  // ========================================

  // #で始まるすべてのアンカーリンクに適用
  const anchorLinks = document.querySelectorAll('a[href^="#"]:not(.js-document)');

  anchorLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');

      // #のみの場合はスキップ
      if (href === '#') return;

      e.preventDefault();

      const targetId = href.replace('#', '');
      const target = document.getElementById(targetId);

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});



// ========================================
// Fixed要素の表示/非表示制御
// ========================================

const fixedElement = document.querySelector('.fixed');
const documentSpSection = document.getElementById('document-sp');

if (fixedElement && documentSpSection) {
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // #document-spが画面内に入ったら非表示
        fixedElement.classList.remove('is-visible');
      } else {
        // #document-spが画面外に出たら表示
        fixedElement.classList.add('is-visible');
      }
    });
  }, {
    threshold: 0.1 // 10%見えたら発火
  });

  observer.observe(documentSpSection);
}


// // ========================================
// // スクロールヒント
// // ========================================
// new ScrollHint(".js-scroll", {
//   i18n: {
//     scrollable: "横スクロール",
//   },
// });
